import type { NaturalEntityModify } from "../utils/types";
import type { NaturalPerson, NaturalPersonDTO, NaturalPersonMissingFields } from "./types";

export const convert_naturalPerson_DTO = (naturalPerson: NaturalPerson): NaturalPersonDTO => ({
  ...naturalPerson,
  countryOfBirth: naturalPerson?.countryOfBirth?.toString() ?? null,
  CountryOfCitizenship: naturalPerson?.CountryOfCitizenship?.toString() ?? null,
  CountryOfCitizenship2: naturalPerson?.CountryOfCitizenship2?.toString() ?? null,
  CountryOfCitizenship3: naturalPerson?.CountryOfCitizenship3?.toString() ?? null,
  CountryOfCitizenship4: naturalPerson?.CountryOfCitizenship4?.toString() ?? null
});

export const convert_naturalPerson_naturalEntityModify = (
  naturalPerson: NaturalPerson
): NaturalEntityModify => ({
  ...naturalPerson,
  countryOfBirth: naturalPerson?.countryOfBirth?.toString() ?? null,
  CountryOfCitizenship: naturalPerson?.CountryOfCitizenship?.toString() ?? null,
  CountryOfCitizenship2: naturalPerson?.CountryOfCitizenship2?.toString() ?? null,
  CountryOfCitizenship3: naturalPerson?.CountryOfCitizenship3?.toString() ?? null,
  CountryOfCitizenship4: naturalPerson?.CountryOfCitizenship4?.toString() ?? null
});

export const map_np_to_np_missing_fields = (
  naturalPerson: NaturalPerson,
  language: string
): NaturalPersonMissingFields => ({
  gender: naturalPerson.Gender,
  lastName: naturalPerson.LastName,
  firstName: naturalPerson.FirstName,
  commonFirstName: naturalPerson.CommonFirstName,
  commonName: naturalPerson.CommonName,
  otherFirstNames: naturalPerson.OtherFirstNames,
  dateOfBirth: naturalPerson.DateOfBirth,
  countryOfCitizenship: naturalPerson.CountryOfCitizenship,
  countryOfCitizenship2: naturalPerson.CountryOfCitizenship2,
  countryOfCitizenship3: naturalPerson.CountryOfCitizenship3,
  countryOfCitizenship4: naturalPerson.CountryOfCitizenship4,
  stateOfBirth: naturalPerson.StateOfBirth,
  address: naturalPerson.Address,
  aliasMobile: naturalPerson.AliasMobile,
  codeLangue: naturalPerson.CodeLangue ?? language,
  activityCode: naturalPerson.ActivityCode,
  cspCode: naturalPerson.CSPCode,
  description: naturalPerson.description,
  countryOfBirth: naturalPerson.countryOfBirth,
  taxAddress: naturalPerson.TaxAddress,
  minimumMonthlyIncome: naturalPerson.minimumMonthlyIncome,
  maximumMonthlyIncome: naturalPerson.maximumMonthlyIncome,
  sourcesIncome: naturalPerson.sourcesIncome,
  activityDescription: naturalPerson.activityDescription
});
